<template>
  <GmailEmailSignalModal
    v-if="isGmailEmail"
    v-bind="props"
    @close="$emit('close')"
  />
  <SignalModal
    v-else
    v-bind="props"
    @close="$emit('close')"
  />
</template>

<script setup>
import { computed } from 'vue'
import SignalModal from './SignalModal.vue'
import GmailEmailSignalModal from './GmailEmailSignalModal.vue'

const props = defineProps({
  signal: { type: Object, required: true },
  accountIdByDomain: { type: Object, default: () => ({}) },
  agentById: { type: Object, default: () => ({}) },
})

defineEmits(['close'])

const isGmailEmail = computed(() => {
  const name = String(props.signal?.name || '').trim()
  return name === 'gmail.inbound_email' || name === 'gmail.outbound_email'
})
</script>
